import * as yup from 'yup';

export const validationSchema = yup.object({
  firstName: yup.string(),
  lastName: yup.string(),
  email: yup.string(),
  phone: yup.string(),
});
